module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "figure"
  }, [_c('a', {
    attrs: {
      "id": "page_xxvi"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pgxxvi_1.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_xxvi"
    }
  }, [_c('p', {
    staticClass: "figcaption"
  }, [_c('b', [_vm._v("The Altai Region.")]), _vm._v(" The mountainous Altai region lies at the center of the map and comprises territory belonging to Russia, China, Mongolia, and Kazakhstan.")])]), _c('div', {
    staticClass: "figure"
  }, [_c('a', {
    attrs: {
      "id": "page_xxvi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xxvii"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pgxxvii_1.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_xxvii"
    }
  }, [_c('p', {
    staticClass: "figcaption"
  }, [_c('b', [_vm._v("Tuva.")]), _vm._v(" The Republic of Tuva (Tyva) shares borders with Mongolia as well as five administrative units of the Russian Federation: Altai Republic, Republic of Xakasia (Khakasia), Krasnoyarsk Krai, Irkutsk Oblast, and the Republic of Buryatia.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5af92196","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/11_FM03.vue
// module id = 84
// module chunks = 0